import React from 'react';

/**
 * A closed notebook with a label plate (mobile's NotebookCover). Sign-up feeds
 * it the name as it's typed, so creating an account reads as naming your own
 * notebook.
 */
export const NotebookCover: React.FC<{ title: string }> = ({ title }) => (
  <div aria-hidden className="relative h-[164px] w-[128px] -rotate-[4deg]">
    {/* Page block peeking out behind the cover. */}
    <span className="absolute left-1 top-1 h-[160px] w-[124px] rounded-r-xl border border-solid border-outline-variant bg-surface-container-lowest" />
    <div className="relative flex h-[160px] w-[124px] flex-col items-center rounded-l-[4px] rounded-r-xl bg-[#2b2a28] shadow-[0_14px_20px_rgba(28,27,25,0.22)]">
      <span className="absolute bottom-0 left-0 top-0 w-[10.5px] rounded-l-[4px] bg-[rgba(0,0,0,0.25)]" />
      <div className="mt-7 flex min-h-[56px] w-[84px] flex-col justify-center rounded-[4px] bg-surface px-2 py-2">
        <span className="line-clamp-2 text-center font-headline text-sm font-medium italic leading-4 text-on-surface">
          {title}
        </span>
        <span className="mx-auto my-1.5 h-px w-5 bg-outline-variant" />
        <span className="text-center font-body text-[8px] font-bold uppercase tracking-[0.2em] text-on-surface-variant">
          No. 01
        </span>
      </div>
      {/* Elastic closure band. */}
      <span className="absolute bottom-0 right-3.5 top-0 w-[5px] bg-[#9a4a2c]" />
    </div>
  </div>
);
